import { env } from '@/lib/env';
import { studioRegistration } from './register';

function urlBase64ToUint8Array(base64: string) {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

export class PushError extends Error {
  constructor(
    readonly reason: 'denied' | 'unavailable' | 'failed',
    message: string,
  ) {
    super(message);
  }
}

/** Asks for permission (only after a tap) and returns the subscription JSON. */
export async function subscribeToPush(): Promise<PushSubscriptionJSON & { userAgent: string }> {
  const registration = await studioRegistration();
  if (!registration) {
    throw new PushError('unavailable', 'Уведомления работают в установленном приложении или после перезагрузки страницы.');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new PushError('denied', 'Уведомления запрещены в настройках браузера.');
  }
  try {
    const existing = await registration.pushManager.getSubscription();
    const subscription =
      existing ??
      (await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(env.VITE_VAPID_PUBLIC_KEY),
      }));
    return { ...subscription.toJSON(), userAgent: navigator.userAgent.slice(0, 280) };
  } catch (error) {
    throw new PushError('failed', `Не удалось включить уведомления: ${(error as Error).message}`);
  }
}

export async function currentPushEndpoint(): Promise<string | null> {
  try {
    const registration = await studioRegistration();
    const subscription = await registration?.pushManager.getSubscription();
    return subscription?.endpoint ?? null;
  } catch {
    return null;
  }
}
